import { combineEpics, Epic, ofType } from "redux-observable";
import { map } from "rxjs/operators";
import { NotificationActions } from "../notifications/actions";
import { ErrorActions } from "./actions";

const processError: Epic<ErrorActions.Actions, any> = (
  action$ //TODO fix typing
) =>
  action$.pipe(
    ofType(ErrorActions.ActionTypes.setError),
    map<ErrorActions.SetError, NotificationActions.SetNotification>((err) =>
      NotificationActions.setNotification({
        title: err.payload?.message,
        variant: "error",
      })
    )
  );
export const errorEpic = combineEpics(processError);
